import { connect } from 'react-redux';

import TranslateTextModal
  from 'zoomforth_codesbane_editor/exterior_editor/sidebar/shared/translate_text_modal_container.jsx';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';


const mapStateToProps = () => {
  return {};
};


const mapDispatchToProps = (dispatch)=> {
  return {
    onClose: ()=> { 
      dispatch(closeModal()); 
    }
  };
};

const TextTranslationEditorModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(TranslateTextModal);

TextTranslationEditorModal.editorModalName = 'TextTranslationEditorModal';

export default TextTranslationEditorModal;
